/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Branch } from '../../models/branch';
import { BranchUpdateRequest } from '../../models/branch-update-request';

export interface UpdateBranch$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: BranchUpdateRequest
}

export function updateBranch(http: HttpClient, rootUrl: string, params: UpdateBranch$Params, context?: HttpContext): Observable<StrictHttpResponse<Branch>> {
  const rb = new RequestBuilder(rootUrl, updateBranch.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Branch>;
    })
  );
}

updateBranch.PATH = '/api/v1/branches/{id}';
